import React from "react"

export default class AddressInput extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="AddressInput">
				<div className="row">
					<div className="col-sm-8">
						<TextInput name="address_1" placeholder="Address 1" onChange={this.onChange} icon={<span className="fa fa-address-card" style={{fontSize: 14}}></span>} />
					</div>
					<div className="col-sm-4">
						<TextInput name="address_2" placeholder="Address 2" onChange={this.onChange} />
					</div>
				</div>
				<div className="row">
					<div className="col-sm-8">
						<TextInput name="city" placeholder="City/Town" onChange={this.onChange} icon={<span className="fa fa-map-marker" style={{left: 15}}></span>} />
					</div>
					<div className="col-sm-4">
						<Selectbox name="state" placeholder="State" value="" options={this.props.states} onChange={this.onChange} />
					</div>
				</div>
				<div className="row">
					<div className="col-sm-6">
						<TextInput name="postal_code" placeholder="Zip Code" onChange={this.onChange} icon={<span className="fa fa-map-marker" style={{left: 15}}></span>} />
					</div>
				</div>
			</div>
		);	
	}

}